import React, { useEffect, useState } from "react";
import { db } from "../../config/firebase";
import { useAuth } from "../../contexts/AuthContext";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import "./Reminder.css";

const Reminder = () => {
  const [reminders, setReminders] = useState([]);
  const [reminderText, setReminderText] = useState("");
  const { getCurrentUserId } = useAuth();
  const [filteredReminders, setFilteredReminders] = useState([]);

  
  // Access currentUserId
  const userId = getCurrentUserId();

  const handleTextChange = (event) => {
    setReminderText(event.target.value);
  };

  const handleAddReminder = () => {
    if (reminderText) {
      const now = new Date();
      const dateOnly = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );
      const newReminder = {
        text: reminderText,
        date: dateOnly.toISOString(), // Save the date only in ISO format
      };

      // Create a reference to the user's document
      const userDocRef = doc(collection(db, "reminders"), userId);

      // Set the user's document with an empty object
      setDoc(userDocRef, {})
        .then(() => {
          // Add the reminder to the userReminders collection
          return addDoc(collection(userDocRef, "userReminders"), newReminder);
        })
        .then((docRef) => {
          // Update the local state with the new reminder
          const newReminders = [
            ...reminders,
            { id: docRef.id, ...newReminder },
          ];
          setReminders(newReminders);

          // Filter the new reminder by today's date and update the filtered reminders state
          const today = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
          ).getTime();
          const newFilteredReminders = [
            ...filteredReminders,
            { id: docRef.id, ...newReminder },
          ].filter((reminder) => {
            const reminderDate = new Date(reminder.date).getTime();
            return reminderDate === today;
          });
          setFilteredReminders(newFilteredReminders);

          setReminderText("");
        })
        .catch((error) => {
          console.error("Error adding reminder: ", error);
        });
    }
  };

  useEffect(() => {
    const fetchReminders = async () => {
      if (!userId) {
        return;
      }
      const remindersRef = collection(db, "reminders");
      const docRef = doc(remindersRef, userId);
      const subcollectionRef = collection(docRef, "userReminders");
      const snapshot = await getDocs(subcollectionRef);
      const remindersData = [];
      for (const doc of snapshot.docs) {
        const reminder = { ...doc.data(), id: doc.id };
        const userRemindersRef = collection(doc.ref, "userReminders");
        const userRemindersQuery = query(userRemindersRef);
        const userRemindersSnapshot = await getDocs(userRemindersQuery);
        const userRemindersData = [];
        userRemindersSnapshot.forEach((userReminderDoc) => {
          const userReminder = {
            ...userReminderDoc.data(),
            id: userReminderDoc.id,
          };
          userRemindersData.push(userReminder);
        });
        reminder.userReminders = userRemindersData;
        remindersData.push(reminder);
      }

      const now = new Date();
      const today = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      ).getTime();

      const filteredReminders = remindersData.filter((reminder) => {
        const reminderDate = new Date(reminder.date).getTime();
        return reminderDate === today;
      });

      setFilteredReminders(filteredReminders);
    };

    fetchReminders();
  }, [userId]);

  const handleDeleteReminder = (reminderId) => {
    const userDocRef = doc(collection(db, "reminders"), userId);
    const reminderDocRef = doc(
      collection(userDocRef, "userReminders"),
      reminderId
    );
    deleteDoc(reminderDocRef)
      .then(() => {
        const newReminders = reminders.filter(
          (reminder) => reminder.id !== reminderId
        );
        setReminders(newReminders);
        const newFilteredReminders = filteredReminders.filter(
          (reminder) => reminder.id !== reminderId
        );
        setFilteredReminders(newFilteredReminders);
      })
      .catch((error) => {
        console.error("Error deleting reminder: ", error);
      });
  };

  return (
    <div className="reminder">
      <h2>Add the Questions You completed today</h2>
      <div>
        <input
          type="text"
          placeholder="Enter the question"
          value={reminderText}
          onChange={handleTextChange}
        />
        <button onClick={handleAddReminder}>Add Reminder</button>
      </div>
      <ul>
        {filteredReminders.map((reminder) => (
          <li key={reminder.id}>
            <div>
              <strong>{reminder.text} </strong>
              <button onClick={() => handleDeleteReminder(reminder.id)}>
                x
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Reminder;
